'use client';

import Button from '@/components/Button';
import { useState, useRef } from 'react';
import { setCookie } from 'cookies-next';
import { Select } from '@/components/Select';
import { Input } from '@/components/Input';
import { useUtmParams, useClearbitParams } from '@/lib/useUtmParams';
import { utmFields, clearbitFields } from '@/lib/pardot-tracking-fields';
import { InternalEvent } from '../../events';
import { buildToolOptions, interestOptions, roleOptions } from './selectOptions';

export function RegisterForm({ event }: { event: InternalEvent }) {
  const [emailError, setEmailError] = useState<string | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const utmParams = useUtmParams();
  const clearbitParams = useClearbitParams();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    const formData = new FormData(form);

    // verify email is correct format
    const email = formData.get('email') as string;
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setEmailError('Please enter a valid email address.');
      e.preventDefault();
      return;
    }

    // Save form data to cookie
    const formValues = {
      first_name: formData.get('first_name'),
      last_name: formData.get('last_name'),
      email: formData.get('email'),
      company: formData.get('company'),
      Build_Tools: formData.get('Build_Tools'),
      Role: formData.get('Role'),
      Areas_of_Interest: formData.get('Areas_of_Interest'),
      webinarId: event.zoomId,
    };

    setCookie('event_registration', JSON.stringify(formValues), {
      maxAge: 60 * 1, // 1 minute
    });
  };

  return (
    <form
      ref={formRef}
      className="grid w-full max-w-[572px] grid-cols-1 gap-4 text-gray-4 md:grid-cols-2 md:gap-6 [&_input]:bg-dark-background [&_input]:text-white [&_select]:bg-dark-background [&_select]:text-white"
      method="POST"
      action={event.pardotFormSubmitLink}
      onSubmit={handleSubmit}
    >
      <Input className="col-span-1" label="First name" name="first_name" required />
      <Input className="col-span-1" label="Last name" name="last_name" required />
      <Input className="col-span-1" label="Email" type="email" name="email" required />
      {emailError && <p className=" text-[#ff0000]">{emailError}</p>}
      <Input className="col-span-1" label="Company" name="company" required />
      <Select
        label="Which build tool do you use the most?"
        name="Build_Tools"
        options={buildToolOptions}
        required
        className="col-span-1 flex w-full flex-col gap-2 md:col-span-2"
      />
      <Select
        label="What is your role?"
        name="Role"
        options={roleOptions}
        required
        className="col-span-1 flex w-full flex-col gap-2 md:col-span-2"
      />
      <Select
        label="What is your main area of interest?"
        name="Areas_of_Interest"
        options={interestOptions}
        required
        className="col-span-1 flex w-full flex-col gap-2 md:col-span-2"
      />
      {utmFields.map(key => (
        <input key={key} type="hidden" id={key} name={key} value={utmParams[key]} />
      ))}
      {clearbitFields.map(key => (
        <input key={key} type="hidden" id={key} name={key} value={clearbitParams[key]} />
      ))}
      <Button type="submit" value="Submit" className="col-span-1 md:col-span-2">
        Save my spot
      </Button>
    </form>
  );
}
